// extracted by mini-css-extract-plugin
export default {"card":"ComponentCard_card__cUvtf"};